module.exports = __webpack_public_path__ + "img/res-1.9aef1354.png";